// The fade is a CSS animation (see .page-fade-in in App.less) so it runs on the compositor
// and doesn't depend on the JS thread, which stalls on slower devices while chunks load.
const PageWrapper = ({ children }) => (
    <div className="page-fade-in">
        {children}
    </div>
);

export default PageWrapper;
